import { render } from "./tep-officials-button.vue?vue&type=template&id=6c6336a6&scoped=true"
import script from "./tep-officials-button.vue?vue&type=script&setup=true&lang=js"
export * from "./tep-officials-button.vue?vue&type=script&setup=true&lang=js"

import "./tep-officials-button.vue?vue&type=style&index=0&id=6c6336a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6336a6"],['__file',"src/views/tep/tep-grid/components/tep-officials-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6336a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6336a6', __exports__)) {
    api.reload('6c6336a6', __exports__)
  }
  
  module.hot.accept("./tep-officials-button.vue?vue&type=template&id=6c6336a6&scoped=true", () => {
    api.rerender('6c6336a6', render)
  })

}


export default __exports__